/**
 * useSessionsListVisit.js — Branche un écran sur la fraîcheur de la liste
 * globale des sessions (useSessionsLoader, D232).
 *
 * Un seul point par shell plutôt qu'un rechargement dans chaque onBack : la
 * liste se recharge à son arrivée à l'écran, qu'on vienne d'un bouton Retour,
 * du menu, du retour du navigateur ou d'un lien direct.
 */
import { useEffect } from 'react';

// visible : la liste est affichée. horseId : filtre cheval à recharger,
// figé au moment de l'arrivée (un changement de filtre recharge déjà).
export function useSessionsListVisit(s, visible, horseId) {
  useEffect(() => {
    if (!visible) return undefined;
    s.enterSessionsList(horseId || null);
    return () => s.leaveSessionsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
}

// active : une page qui peut modifier les sessions est affichée (vue d'une
// session). Couvre le lien direct vers une session : la liste n'a jamais été
// quittée, mais elle est périmée au retour.
export function useSessionsAway(s, active) {
  useEffect(() => {
    if (active) s.markSessionsStale();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);
}
